/******/ (() => {
  var __webpack_exports__ = {};
  Shopify.theme.jsFeaturedCollection = {
    init: function ($section) {
      // Read all section data safely (don’t rely on mutating `this`)
      const data = Shopify.theme.getSectionData($section) || {};
      const $sliderEl = $section.find('[data-slider]');
      const $arrows   = $section.find('.custom-slider-arrows');
      const breakpoint = Number(data.mobile_breakpoint || 768);
      const mql = window.matchMedia(`(max-width: ${breakpoint}px)`);
      const self = this;

      function isMobile() { return mql.matches; }
      function hasSliderInstance() { return !!$section.data('fcInstance'); }

      function create() {
        if (!$sliderEl.length || hasSliderInstance()) return;

        const slider = $sliderEl.flickity({
          lazyLoad: 2,
          freeScroll: true,
          imagesLoaded: true,
          draggable: true,
          cellAlign: 'left',
          wrapAround: false,
          pageDots: false,
          contain: true,
          prevNextButtons: false,
          initialIndex: 0,
          
        });

        // Store instance on the section so multiple sections don’t clash
        $section.data('fcInstance', slider);

        const $prevArrow = $section.find('.arrow-prev');
        const $nextArrow = $section.find('.arrow-next');

        function updateArrowStates() {
          const flkty = slider.data('flickity');
          if (!flkty) return;
          $prevArrow.toggleClass('disabled', flkty.selectedIndex === 0);
          $nextArrow.toggleClass('disabled', flkty.selectedIndex >= flkty.slides.length - 1);
        }

        $prevArrow.on('click.fc', function(e){
          e.preventDefault();
          if (!$(this).hasClass('disabled')) slider.flickity('previous');
        });
        $nextArrow.on('click.fc', function(e){
          e.preventDefault();
          if (!$(this).hasClass('disabled')) slider.flickity('next');
        });

        updateArrowStates();
        slider.on('change.flickity', updateArrowStates);
        slider.on('settle.flickity', function(){ slider.flickity('resize'); });

        $arrows.removeClass('is-hidden');
      }

      function destroy() {
        const slider = $section.data('fcInstance');
        if (!slider) {
          $arrows.addClass('is-hidden');
          $section.find('.arrow-prev, .arrow-next').off('click.fc');
          return;
        }
        // Unbind arrow handlers (namespaced)
        $section.find('.arrow-prev, .arrow-next').off('click.fc');

        // Destroy flickity instance
        const $enabled = $section.find('.flickity-enabled');
        if ($enabled.length) $enabled.flickity('destroy');

        $section.removeData('fcInstance');
        $arrows.addClass('is-hidden');
      }

      function apply() {
        // Only act when layout is slider
        if (data.collection_style !== 'slider') {
          destroy();
          return;
        }
        // Respect “Disable on mobile”
        if (data.disable_slider_mobile && isMobile()) {
          destroy();
        } else {
          create();
        }
      }

      // Initial run + respond to breakpoint changes
      apply();
      if (mql.addEventListener) {
        mql.addEventListener('change', apply);
      } else {
        // Safari < 14 fallback
        mql.addListener(apply);
      }
    },

    unload: function ($section) {
      // Cleanly destroy when section is removed
      const slider = $section.data('fcInstance');
      if (slider) {
        const $enabled = $section.find('.flickity-enabled');
        if ($enabled.length) $enabled.flickity('destroy');
        $section.removeData('fcInstance');
      }
      $section.find('.arrow-prev, .arrow-next').off('click.fc');
    }
  }
})();